import React, { Fragment, useEffect, useState } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Row,
  InputGroup,
  Input,
} from "reactstrap";
import Select from "react-select";
import { Country } from "country-state-city";
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { getIndustryData, addPackages, getTaxGroup } from "../../../CommonURL";
import { getDataWithToken, postDataWithToken } from "../../../Utils/restUtils";
import {
  DiscriptionText,
  Name,
  NameError,
  SubmitForm,
  AddPackages,
  Features,
  Price,
  MRP,
  TaxGroup,
  Industry,
  SetupCost,
  ExpiryDate,
  Days,
  FeaturesError,
  PriceError,
  MrpError,
  TaxGroupError,
  IndustryError,
  SetupCostError,
  ExpiryDateError,
  DaysError,
  HSN,
  UsingLocales,
  MinConnection,
  MaxConnection,
  PriceCalculation,
  TaxClass,
  SMSActive,
  MaxError,
  MinError,
  PriceCalError,
  Currency,
  Currencys,
} from "../../../Constant";
import Typeahead from "../../../CommonElements/TypeAhead";
import SpinnerLoader from "../../../Layout/SpinnerLoader";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import { toast } from "react-toastify";

const PackagesForm = () => {
  const schema = Yup.object()
    .shape({
      industry: Yup.mixed().required(),
      taxGroup: Yup.mixed().required(),
      setupCost: Yup.number().required(),
      name: Yup.string().required(),
      features: Yup.string().required(),
      price: Yup.number().required(),
      mrp: Yup.number().required(),
      minCon: Yup.number()
        .typeError("Minimum connection is required")
        .required(),

      maxCon: Yup.number()
        .typeError("Maximum connection is required")
        .required(),

      priceCal: Yup.mixed().required(),
      expiryDate: Yup.number().required(),
      hsn: Yup.string().required().typeError("HSN is required"),
    })
    .required();
  const defaultCountry = Country.getAllCountries().find((c) => c.name === "India");

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      currency: { value: "INR", label: "Indian Rupee" },
      country: defaultCountry,
      country_name: defaultCountry?.name,
      country_iso: defaultCountry?.isoCode,
    },
  });
  const [industry, setIndustry] = useState([]);
  const [tax, setTax] = useState([]);
  const [taxOption, setTaxOption] = useState([]);
  const [industryOption, setIndustryOption] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(defaultCountry);
  const navigate = useNavigate();

  const priceCalOptions = [
    { value: "fixed", label: "Fixed Amount" },
    { value: "per_unit", label: "Per Unit" },
  ];
  const currencyOptions = [
    { value: "INR", label: "Indian Rupee" },
    { value: "USD", label: "US Dollar" },
  ];
  useEffect(() => {
    industryData();
    taxData();
  }, []);

  useEffect(() => {
    setTaxOption(
      tax.map((item) => ({
        value: item.id,
        label: item.title,
      })),
    );
    setIndustryOption(
      industry.map((item) => ({
        value: item.id,
        label: item.name,
      })),
    );
  }, [tax, industry]);

  const industryData = async () => {
    const data = await getDataWithToken(getIndustryData);
    setIndustry(data.data);
  };

  const taxData = async () => {
    const getTaxdata = await getDataWithToken(getTaxGroup);
    setTax(getTaxdata.data);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const postRequest = {
      name: data.name,
      price: data?.price,
      mrp: data?.mrp,
      tax_group_id: data.taxGroup.value,
      industry_type_id: data?.industry?.value,
      features: data.features,
      setup_cost: data?.setupCost,
      duration: data.expiryDate,
      min_connection: data?.minCon,
      hsn_no: data?.hsn,
      max_connection: data?.maxCon,
      price_calculation: data?.priceCal?.value,
      currency: data?.currency?.value,
      country: data.country_name,
      iso_code: data.country_iso,
      sms: data?.sms,
    };
    const addPackageResponse = await postDataWithToken(
      addPackages,
      postRequest,
    );

    const message = addPackageResponse?.data?.message;

    if (message === "success") {
      navigate(`${process.env.PUBLIC_URL}/configuration/packages`);
    } else if (message === "Package already exist") {
      toast.error("Package already exists");
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    }

    setLoading(false);
  };
  return (
    <Fragment>
      {loading && <Transparentspinner />}

      <Breadcrumbs
        mainTitle="Add Packages"
        parent="Configuration"
        title="Packages"
      />
      <Card>
        <CardHeader className="pb-0">
          <H3>{AddPackages}</H3>
          {/* <span>{CustomstyleText} <code className="text-danger">{novalidate}</code> {CustomstyleText2} <code className="text-danger">&lt;{form}&gt;</code>{CustomstyleText3}</span><span>{CustomstyleText4} <code className="text-danger">{invalid} </code> {and} <code className="text-danger">{valid} </code> {CustomstyleText5}</span> */}
        </CardHeader>
        <CardBody>
          <Form
            className="needs-validation"
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row className="g-3">
              <Col md="6">
                <Label className="form-label" for="validationCustom02">
                  {Industry} <span className="requireStar">*</span>
                </Label>
                <Controller
                  name="industry"
                  control={control} // Set the initial value to null
                  render={({ field }) => (
                    <Typeahead
                      options={industryOption}
                      onChange={(value) => {
                        field.onChange(value); // Update the value in react-hook-form
                      }}
                      value={field.value}
                    />
                  )}
                />

                <span className="text-danger">
                  {errors.industry ? IndustryError : ""}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="validationCustom01">
                  {Name} <span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="validationCustom01"
                  placeholder="Name"
                  type="text"
                  {...register("name", { required: true })}
                />
                <span className="text-danger">
                  {errors.name ? NameError : ""}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="validationCustom01">
                  {HSN} <span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="validationCustom01"
                  placeholder="HSN"
                  type="number"
                  min="0"
                  {...register("hsn", { required: true })}
                />
                <span className="text-danger">{errors.hsn?.message}</span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="validationCustom01">
                  {MinConnection} <span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="validationCustom01"
                  placeholder="Minimum Connection"
                  type="number"
                  min="0"
                  {...register("minCon", { required: true })}
                />
                <span className="text-danger">
                  {errors.minCon ? MinError : ""}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="validationCustom02">
                  {MaxConnection} <span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="validationCustom02"
                  placeholder="Maximum Connection"
                  type="number"
                  min="0"
                  {...register("maxCon", { required: true })}
                />
                <span className="text-danger">{errors.maxCon && MaxError}</span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="validationCustom01">
                  {PriceCalculation} <span className="requireStar">*</span>
                </Label>
                <Controller
                  name="priceCal"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={priceCalOptions}
                      value={field.value}
                      onChange={field.onChange}
                    />
                  )}
                />

                <span className="text-danger">
                  {errors.priceCal ? PriceCalError : ""}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="validationCustom01">
                  {Currencys} <span className="requireStar">*</span>
                </Label>
                <Controller
                  name="currency"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={currencyOptions}
                      value={field.value}
                      onChange={field.onChange}
                    />
                  )}
                />

                <span className="text-danger">{errors.currency?.message}</span>
              </Col>
              <Col md="6">
                <Label className="form-label">
                  Country <span className="requireStar">*</span>
                </Label>

                <Controller
                  name="country"
                  control={control}
                  rules={{ required: "Country is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={Country.getAllCountries()}
                      getOptionLabel={(opt) => opt.name}
                      getOptionValue={(opt) => opt.isoCode}
                      value={selectedCountry}
                      onChange={(item) => {
                        setSelectedCountry(item);

                        // store full object (optional)
                        field.onChange(item);

                        // store separately if needed
                        setValue("country_name", item.name);
                        setValue("country_iso", item.isoCode);
                      }}
                    />
                  )}
                />

                <span className="text-danger">{errors.country?.message}</span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="validationCustom01">
                  {Price} <span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="validationCustom01"
                  placeholder="Price"
                  type="number"
                  min="0"
                  {...register("price", { required: true })}
                />
                <span className="text-danger">
                  {errors.price ? PriceError : ""}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="validationCustom02">
                  {MRP} <span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="validationCustom02"
                  placeholder="MRP"
                  type="number"
                  min="0"
                  {...register("mrp", { required: true })}
                />
                <span className="text-danger">{errors.mrp && MrpError}</span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="validationCustom02">
                  {SetupCost} <span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="validationCustom02"
                  placeholder="Setup Cost "
                  type="number"
                  min="0"
                  {...register("setupCost", { required: true })}
                />
                <span className="text-danger">
                  {errors.setupCost && SetupCostError}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="validationCustom01">
                  {TaxClass} <span className="requireStar">*</span>
                </Label>
                <Controller
                  name="taxGroup"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={taxOption}
                      value={field.value}
                      onChange={field.onChange}
                    />
                  )}
                />

                <span className="text-danger">
                  {errors.taxGroup ? TaxGroupError : ""}
                </span>
              </Col>
              <Col md="6">
                <FormGroup className="mb-3">
                  <Label className="form-label" for="validationCustom02">
                    {ExpiryDate}
                    <span className="requireStar">*</span>
                  </Label>
                  <input
                    className="form-control"
                    id="validationCustom02"
                    placeholder="Expiry Duration "
                    type="number"
                    min="0"
                    {...register("expiryDate", { required: true })}
                  />
                  <span className="text-danger">
                    {errors.expiryDate && ExpiryDateError}
                  </span>
                </FormGroup>
              </Col>
            </Row>
            <Row className="g-3">
              <Col md="6">
                <div className="form-check checkbox checkbox-primary mb-0">
                  <input
                    id="checkbox-primary-1"
                    type="checkbox"
                    {...register("sms", { required: true })}
                    defaultChecked={false}
                  />
                  {/* <Input id="checkbox-primary-1" type="checkbox" {...register('sms', { required: true })}/> */}
                  <Label for="checkbox-primary-1">{SMSActive}</Label>
                </div>
              </Col>
            </Row>
            <Row className="g-3">
              <Col>
                <Label className="form-label pt-3">
                  {Features} <span className="requireStar">*</span>
                </Label>
                <Controller
                  name="features"
                  control={control}
                  render={({ field }) => (
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Features"
                      {...field}
                    />
                  )}
                />

                <span className="text-danger">
                  {errors.features ? FeaturesError : ""}
                </span>
              </Col>
            </Row>
            <FormGroup></FormGroup>
            <Btn attrBtn={{ color: "primary" }} type="submit">
              {SubmitForm}
            </Btn>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default PackagesForm;
